<template>
  <div class="p-auth-layout app-root">
    <PHeader />
    <main>
      <div class="container">
        <div class="row">
          <div class="offset-sm-4 col-12 col-sm-4">
            <slot />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import Header from './Header.vue'
export default {
  components: {
    PHeader: Header,
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/utils/breakpoints';

.app-root {
  padding-top: 64px;

  @include breakpoints.media-breakpoint-down(md) {
    padding-top: 48px;
  }
}
</style>
